<template>
	<v-container>
		<v-app-bar dense dark app color="secondary">
			<v-toolbar-title> Importar Eventos </v-toolbar-title>
		</v-app-bar>
		<v-card>
			<v-card-title> Como importar eventos </v-card-title>

			<v-list-item>
				<v-list-item-content>
					<v-list-item-title>1. Baixe o modelo de planilha</v-list-item-title>
					<div>
						<v-btn
							color="primary"
							href="/templates/Template de importação de eventos.xlsx"
							download="Template de importação de eventos.xlsx"
							class="mt-2"
						>
							Modelo Excel
						</v-btn>
					</div>
				</v-list-item-content>
			</v-list-item>

			<v-list-item>
				<v-list-item-content>
					<v-list-item-title>2. Abra em um programa de planilhas (como Google Planilhas ou Excel)</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-list-item>
				<v-list-item-content>
					<v-list-item-title>3. Preencha cada linha certificando que:</v-list-item-title>
					<v-list-item-subtitle>	
						<div>- As datas estão no formato correto (dd/mm/yyyy)</div>
						<div>- Tenha o grau em caso de sessão da loja</div>
					</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>

			<v-list-item>
				<v-list-item-content>
					<v-list-item-title>4. Importe o arquivo</v-list-item-title>
					<div>
						<v-btn
							color="primary"
							@click="iniciarUpload"
							:disabled="isPending"
							:loading="isPending"
						>
							Importar
						</v-btn>
					</div>

					<input
						style="display: none;"
						@change="handleFileChange"
						type="file"
						accept=".xlsx"
						ref="campoDeUpload"
						show-size
						required
						:disabled="isPending"
					/>
				</v-list-item-content>
			</v-list-item>
			<v-alert v-if="error" type="error">
				<div v-for="(message, index) in errorMessages" :key="index">{{ message }}</div>
			</v-alert>
			<v-alert v-if="data" type="success">
				{{ data.message }}
			</v-alert>
		</v-card>
		<DialogoDeConfirmacao ref="dialogoDeConfirmacao" />
	</v-container>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import ImportacaoService from '@/services/ImportacaoService'
import { getErrorMessage } from '@/helpers/error-helpers';
import DialogoDeConfirmacao from '@/components/dialogos/DialogoDeConfirmacao.vue'

const dialogoDeConfirmacao = ref<InstanceType<typeof DialogoDeConfirmacao> | null>(null)
const selectedFile = ref<File | null>(null)
const campoDeUpload = ref<HTMLInputElement | null>(null)

const queryClient = useQueryClient()

const { mutate, isPending, error, data, reset } = useMutation({
	mutationFn: async (arquivo: File) => {
		const formData = new FormData()
		formData.append('file', arquivo)
		return ImportacaoService.importar('eventos', formData)
	},
	onSuccess() {
		selectedFile.value = null
		queryClient.invalidateQueries({ queryKey: ['eventos'], exact: false })
	},
})

function iniciarUpload() {
	if (!campoDeUpload.value) return
	campoDeUpload.value.click()
}

const handleFileChange = async (event: Event) => {
	const target = event.target as HTMLInputElement
	const file = target.files?.[0]
	if (!file) return

	target.value = ''
	const confirmado = await dialogoDeConfirmacao.value?.abrir({
		titulo: 'Confirmação',
		mensagem: `Tem certeza que deseja importar "${file.name}"?`,
	})
	reset()
	if (confirmado) mutate(file)
}

const errorMessages = computed(() => error ? getErrorMessage(error.value).split('\n') : [])
</script>